module.exports = __webpack_public_path__ + "static/media/BadgeRR.bf395182.svg";